import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Plus } from "lucide-react";
import { sectionMapper } from "../../../utils";
import Button from "../../../components/ui/Button";
import Card from "./Card";

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  transform: isDragging ? "scale(1.1)" : null,
  // styles we need to apply on draggables
  ...draggableStyle,
});

function CardList({
  slides,
  onDragEnd,
  handleAddSlide,
  onCardDelete,
  onCardChange,
  section,
}) {
  return (
    <div className="pt-5">
      <div className="flex justify-between items-center mb-11">
        <h2 className="text-xl font-semibold text-slate-600 w-full text-left">
          {`${sectionMapper[section]} Section Cards Outline`}
        </h2>

        <Button
          onClick={() => handleAddSlide(section)}
          className="font-bold text-sm whitespace-nowrap"
          type="ghost"
          size="small"
          startIcon={<Plus className="w-5" />}
        >
          Add slide
        </Button>
      </div>
      <div className="max-h-[72vh] overflow-auto mt-5 px-1">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={section} key={section}>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="border-stone-300"
              >
                <div className="pt-5 mb-3">
                  {slides[section].map((slide, index) => (
                    <Draggable
                      key={slide.id}
                      draggableId={slide.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <Card
                          innerRef={provided.innerRef}
                          provided={provided}
                          stil={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                          section={section}
                          index={index}
                          slide={slide}
                          onDelete={() => onCardDelete(section, index)}
                          onInputChange={(value) =>
                            onCardChange(section, index, value)
                          }
                        />
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
}

export default CardList;
